// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__1cZQn","label":"styles_label__8FA3I","double":"styles_double__TJpqf","main":"styles_main__LyX8M","hash":"styles_hash__14SIV"};